import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',
      backgroundColor: BackgroundColors.transparent,
      maxWidth: '100%',
      width: '100%',
      aspectRatio: '16 / 9',
      overflow: 'hidden',
      borderRadius: CornerRadius.r24,
    },
    skeletonRoot: {
      extend: 'root',
      height: '100vh',
    },
  }),
  { name: 'embed-video' },
);

export default useStyles;
